import { GAME_ID, REDUX_ACTIONS } from '../../../data/constants';
import { worksheetActionTypes } from '../../../../components/worksheet/data/constants';
import AlexStates from '../../../../components/GameHeader/AlexStates';

export const initialState = {
  alexState: AlexStates.INACTIVE,
  backButtonVisible: true,
  currentVO: 'none',
  VOPriority: 0,
  indexInStack: 0,
  VOStack: [],
  hasInitiatedItem: false,
  helpIndex: 0,
};

const actionsThatCancelAlexSpeech = [
  worksheetActionTypes.ON_CORRECT_START,
  worksheetActionTypes.ON_INCORRECT_START,
];

const HeaderReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  for (let i = 0; i < actionsThatCancelAlexSpeech.length; i++) {
    if (type === actionsThatCancelAlexSpeech[i]) {
      return { ...initialState };
    }
  }

  switch (type) {
    case REDUX_ACTIONS.SET_ALEX_STATE:
      return {
        ...state,
        alexState: payload,
      };

    case REDUX_ACTIONS.SET_ALEX_VO_FILE:
      if (payload.priority >= state.VOPriority) {
        if (typeof payload.VO === 'string') {
          return {
            ...state,
            currentVO: payload.VO,
            VOPriority: payload.priority,
            alexState: AlexStates.SPEAKING,
            VOStack: [],
          };
        } if (typeof payload.VO === 'object') {
          return {
            ...state,
            currentVO: payload.VO[0],
            VOPriority: payload.priority,
            alexState: AlexStates.SPEAKING,
            indexInStack: 0,
            VOStack: payload.VO,
          };
        }
      }
      return state;

    case REDUX_ACTIONS.CONCLUDE_VO: {
      const { indexInStack, VOStack, VOPriority } = state;
      const nextIndexInStack = indexInStack + 1;
      let currentVO = 'none';
      let alexState = AlexStates.INACTIVE;
      let nextVOPriority = 0;

      if (nextIndexInStack < VOStack.length) {
        currentVO = VOStack[nextIndexInStack];
        alexState = AlexStates.SPEAKING;
        nextVOPriority = VOPriority;
      }

      return {
        ...state,
        currentVO,
        VOPriority: nextVOPriority,
        alexState,
        indexInStack: state.indexInStack + 1,
      };
    }

    case REDUX_ACTIONS.SET_SINGLE_IMAGE_ZOOM:
    case REDUX_ACTIONS.SET_COMIC_ZOOM:
      return {
        ...state,
        backButtonVisible: !payload,
        hasInitiatedItem: true,
      };

    case REDUX_ACTIONS.SET_SCROLLVIEW_LEFT_ALIGNED:
      return {
        ...state,
        hasInitiatedItem: payload ? true : state.hasInitiatedItem,
      };

    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        ...initialState,
      };

    case REDUX_ACTIONS.INIT_STANDARD_ITEM:
      return {
        ...state,
        hasInitiatedItem: false,
        helpIndex: 0,
      };

    case REDUX_ACTIONS.INCREMENT_HELP_INDEX:
      return {
        ...state,
        helpIndex: state.helpIndex + 1,
      };

    case REDUX_ACTIONS.RESET_HELP_INDEX:
      return {
        ...state,
        helpIndex: 0,
      };

    default:
      return state;
  }
};

export default HeaderReducer;
